import React, { useId } from 'react';

import { FormControlContainer, TextCheckbox } from './styled';

interface ICheckbox extends React.ComponentPropsWithoutRef<'input'> {
	label?: string;
}

// eslint-disable-next-line react/display-name
export const TypeCheckbox = React.forwardRef(({ label, ...props }: ICheckbox, ref) => {
	const generatedId = useId();
	const checkboxId = props.id || props.name || generatedId;

	return (
		<FormControlContainer
			style={{
				flexDirection: 'row',
				alignItems: 'center',
				gap: '8px',
				minHeight: '44px',
			}}
		>
			<label
				htmlFor={checkboxId}
				style={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: '10px',
					margin: 0,
					padding: '8px 4px',
					minHeight: '44px',
					cursor: props.disabled ? 'not-allowed' : 'pointer',
					userSelect: 'none',
				}}
			>
				<TextCheckbox
					{...props}
					id={checkboxId}
					ref={ref as React.LegacyRef<HTMLInputElement> | undefined}
					type='checkbox'
					aria-checked={props.checked}
				/>
				{label && (
					<span
						style={{
							fontSize: '14px',
							color: 'var(--color-text-primary)',
						}}
					>
						{label}
					</span>
				)}
			</label>
		</FormControlContainer>
	);
});
